import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ip.market.buyer.inquiries');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type ConsultationCategory =
    | 'BUY_INQUIRY'
    | 'RIGHT_SPECIFIC_QNA'
    | 'REQUIREMENT_QNA'
    | 'CASE_CONSULTATION';
type ConsultationStatus =
    | 'RECEIVED'
    | 'ASSIGNED'
    | 'IN_PROGRESS'
    | 'ON_HOLD'
    | 'COMPLETED'
    | 'CANCELLED';

type Requester = {
    office_name: string;
    name: string;
    phone: string;
    email: string;
};

type ConsultationListItem = {
    id: string;
    source: 'IP_MARKET_PORTAL';
    category: ConsultationCategory;
    subject: string;
    requester: Requester;
    privacy_consent: boolean;
    status: ConsultationStatus;
    assigned_to: string | null;
    created_at: string;
    updated_at: string;
    body_preview: string;
};

type StatusHistory = {
    id: string;
    from_status: ConsultationStatus | null;
    to_status: ConsultationStatus;
    changed_by: string;
    reason: string;
    created_at: string;
};

type ConsultationMessage = {
    id: string;
    body: string;
    visibility: 'INTERNAL' | 'PUBLIC';
    created_by: string;
    created_at: string;
};

type ReplyAttachment = {
    id: string;
    file_name: string;
    mime_type: string;
    size_bytes: number;
    status: 'DRAFT' | 'PENDING' | 'SENT';
    created_at: string;
    created_by: string;
    sent_at: string;
};

type ConsultationDetail = ConsultationListItem & {
    body: string;
    status_history: StatusHistory[];
    messages: ConsultationMessage[];
    reply_attachments: ReplyAttachment[];
    audit_events: any[];
};

type Pagination = {
    page: number;
    limit: number;
    total: number;
    total_pages: number;
};

type BuyerDetailTab = 'overview' | 'processing' | 'documents';

@Component({
    selector: 'wiz-page-ip-market-buyer-inquiries',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ip.market.buyer.inquiries/view.scss */
:host {
  display: block;
  height: 100%;
}

.buyer-detail-summary {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(20rem, 28rem);
  gap: 1rem;
  align-items: stretch;
  padding: 1rem 1.25rem;
  border-bottom: 1px solid #e2e8f0;
  background: radial-gradient(circle at 100% 0, rgba(8, 145, 178, 0.07), transparent 18rem), #fff;
}

.buyer-detail-summary__copy {
  min-width: 0;
  align-self: center;
}

.buyer-detail-summary__copy h2 {
  margin-top: 0.55rem;
  color: #0f172a;
  font-size: 1rem;
  font-weight: 800;
  line-height: 1.45rem;
}

.buyer-detail-summary__copy p {
  margin-top: 0.25rem;
  color: #94a3b8;
  font-size: 0.68rem;
}

.buyer-status-card {
  padding: 0.8rem;
  border: 1px solid #bae6fd;
  border-radius: 0.75rem;
  background: rgba(240, 249, 255, 0.78);
}

.buyer-status-card__heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.75rem;
}

.buyer-status-card__heading h3 {
  color: #0f172a;
  font-size: 0.75rem;
  font-weight: 800;
}

.buyer-status-card__heading p {
  margin-top: 0.15rem;
  color: #64748b;
  font-size: 0.62rem;
  line-height: 1rem;
}

.buyer-status-card__controls {
  display: grid;
  grid-template-columns: 7.25rem minmax(0, 1fr) auto;
  gap: 0.45rem;
  margin-top: 0.65rem;
}

.buyer-detail-tabs {
  position: sticky;
  z-index: 4;
  top: 3rem;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0.65rem 1rem;
  border-bottom: 1px solid #dbe4ea;
  background: rgba(248, 250, 252, 0.96);
  backdrop-filter: blur(10px);
}

.buyer-detail-tabs button {
  display: flex;
  min-width: 0;
  min-height: 3.25rem;
  align-items: center;
  gap: 0.7rem;
  padding: 0.55rem 0.7rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.7rem;
  color: #64748b;
  background: #fff;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, color 140ms ease, box-shadow 140ms ease;
}

.buyer-detail-tabs button:hover {
  border-color: #bae6fd;
  color: #0e7490;
}

.buyer-detail-tabs button:focus-visible {
  outline: 2px solid #06b6d4;
  outline-offset: 1px;
}

.buyer-detail-tabs button.is-active {
  border-color: #67e8f9;
  color: #0e7490;
  background: #ecfeff;
  box-shadow: 0 6px 18px rgba(8, 145, 178, 0.1);
}

.buyer-detail-tabs i {
  display: inline-flex;
  width: 2rem;
  height: 2rem;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 0.55rem;
  color: #64748b;
  background: #f1f5f9;
  font-size: 0.78rem;
}

.buyer-detail-tabs button.is-active i {
  color: #fff;
  background: #0891b2;
}

.buyer-detail-tabs span {
  display: flex;
  min-width: 0;
  flex-direction: column;
}

.buyer-detail-tabs strong {
  overflow: hidden;
  color: inherit;
  font-size: 0.76rem;
  font-weight: 800;
  line-height: 1rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.buyer-detail-tabs small {
  overflow: hidden;
  margin-top: 0.15rem;
  color: #94a3b8;
  font-size: 0.6rem;
  line-height: 0.9rem;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.buyer-detail-body {
  min-height: 31rem;
  padding: 1rem;
  background: #f8fafc;
}

.buyer-detail-panel[hidden] {
  display: none !important;
}

.buyer-detail-panel {
  animation: buyer-panel-enter 150ms ease-out both;
}

.buyer-panel-heading,
.buyer-card-heading {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
}

.buyer-panel-heading {
  margin-bottom: 0.9rem;
}

.buyer-panel-heading__eyebrow {
  color: #0891b2;
  font-size: 0.58rem;
  font-weight: 800;
  letter-spacing: 0.12em;
}

.buyer-panel-heading h3 {
  margin-top: 0.2rem;
  color: #0f172a;
  font-size: 0.92rem;
  font-weight: 800;
}

.buyer-panel-heading > div > p:last-child,
.buyer-card-heading p {
  margin-top: 0.18rem;
  color: #64748b;
  font-size: 0.65rem;
  line-height: 1rem;
}

.buyer-overview-grid {
  display: grid;
  grid-template-columns: minmax(17rem, 0.8fr) minmax(0, 1.2fr);
  gap: 0.9rem;
}

.buyer-section-card {
  min-width: 0;
  padding: 1rem;
  border: 1px solid #dbe4ea;
  border-radius: 0.8rem;
  background: #fff;
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.035);
}

.buyer-section-card h4 {
  color: #334155;
  font-size: 0.76rem;
  font-weight: 800;
}

.buyer-info-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.9rem 1rem;
  margin-top: 1rem;
}

.buyer-info-grid dt {
  color: #94a3b8;
  font-size: 0.66rem;
}

.buyer-info-grid dd {
  margin-top: 0.2rem;
  color: #334155;
  font-size: 0.76rem;
  font-weight: 650;
}

.buyer-consultation-copy {
  min-height: 11rem;
  margin-top: 0.85rem;
  padding: 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.65rem;
  color: #475569;
  background: #f8fafc;
  font-size: 0.76rem;
  line-height: 1.65rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.buyer-card-chip {
  flex: 0 0 auto;
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  color: #475569;
  background: #f1f5f9;
  font-size: 0.62rem;
  font-weight: 750;
}

.buyer-card-chip--sky {
  color: #0369a1;
  background: #e0f2fe;
}

.buyer-card-chip--indigo {
  color: #4338ca;
  background: #eef2ff;
}

.buyer-document-card {
  border-color: #c7d2fe;
  background: linear-gradient(145deg, #fff, #f8faff);
}

.buyer-document-empty {
  display: flex;
  min-height: 12rem;
  margin-top: 1rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 1px dashed #cbd5e1;
  border-radius: 0.7rem;
  color: #94a3b8;
  background: #f8fafc;
  text-align: center;
}

.buyer-document-empty i {
  font-size: 1.2rem;
}

.buyer-document-empty p {
  margin-top: 0.55rem;
  font-size: 0.75rem;
  font-weight: 700;
}

.buyer-document-empty span {
  margin-top: 0.25rem;
  font-size: 0.62rem;
}

@keyframes buyer-panel-enter {
  from {
    opacity: 0;
    transform: translateY(0.2rem);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 820px) {
  .buyer-detail-summary {
    grid-template-columns: minmax(0, 1fr);
  }
  .buyer-overview-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media (max-width: 640px) {
  .buyer-status-card__controls {
    grid-template-columns: minmax(0, 1fr);
  }
  .buyer-detail-tabs {
    grid-template-columns: repeat(3, minmax(9.5rem, 1fr));
    overflow-x: auto;
  }
  .buyer-detail-body {
    padding: 0.75rem;
  }
  .buyer-info-grid {
    grid-template-columns: minmax(0, 1fr);
  }
}`],
})
export class PageIpMarketBuyerInquiriesComponent implements OnInit {
    public categories: ConsultationCategory[] = [
        'BUY_INQUIRY',
        'RIGHT_SPECIFIC_QNA',
        'REQUIREMENT_QNA',
        'CASE_CONSULTATION'
    ];
    public statuses: ConsultationStatus[] = [
        'RECEIVED',
        'ASSIGNED',
        'IN_PROGRESS',
        'ON_HOLD',
        'COMPLETED',
        'CANCELLED'
    ];
    public filters: any = {
        category: '',
        status: '',
        assigned_to: '',
        q: '',
        page: 1,
        limit: 20
    };
    public items: ConsultationListItem[] = [];
    public pagination: Pagination = { page: 1, limit: 20, total: 0, total_pages: 1 };
    public selected: ConsultationDetail | null = null;
    public loading: boolean = false;
    public detailLoading: boolean = false;
    public saving: boolean = false;
    public errorMessage: string = '';
    public assigneeDraft: string = '';
    public statusDraft: ConsultationStatus = 'RECEIVED';
    public statusReason: string = '';
    public messageDraft: string = '';
    public replyDraft: string = '';
    public uploadingReplyAttachments: boolean = false;
    public replyUploadProgress: number = 0;
    public deletingAttachmentId: string = '';
    public sendingReply: boolean = false;
    public activeDetailTab: BuyerDetailTab = 'overview';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load(resetPage: boolean = false) {
        if (this.loading) return;
        if (resetPage) this.filters.page = 1;

        const previousId = this.selected?.id || '';
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('list_market_consultations', this.filters);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '구매상담 목록을 불러오지 못했습니다.'));
            }
            const data = response.data || {};
            this.items = Array.isArray(data.items) ? data.items : [];
            this.pagination = data.pagination || {
                page: this.filters.page,
                limit: this.filters.limit,
                total: this.items.length,
                total_pages: 1
            };
            this.filters.page = this.pagination.page || 1;

            const next = previousId
                ? this.items.find((item) => item.id === previousId)
                : null;
            if (next) {
                await this.loadDetail(next.id, false);
            } else {
                this.selected = null;
            }
        } catch (error) {
            this.items = [];
            this.selected = null;
            this.errorMessage = this.errorText(error, '구매상담 목록을 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async loadDetail(id: string, render: boolean = true) {
        if (!id || this.detailLoading) return;
        const switchingConsultation = this.selected?.id !== id;
        this.detailLoading = true;
        this.errorMessage = '';
        if (render) await this.service.render();
        try {
            const response = await wiz.call('get_market_consultation', { id });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '구매상담 상세를 불러오지 못했습니다.'));
            }
            this.applyDetail(response.data as ConsultationDetail);
            if (switchingConsultation) {
                this.replyDraft = '';
                this.activeDetailTab = 'overview';
            }
            this.updateListItem(this.selected);
        } catch (error) {
            this.selected = null;
            this.errorMessage = this.errorText(error, '구매상담 상세를 불러오지 못했습니다.');
            if (render) await this.service.modal.error(this.errorMessage);
        } finally {
            this.detailLoading = false;
            if (render) await this.service.render();
        }
    }

    public async closeDetail() {
        if (this.detailLoading || this.saving || this.uploadingReplyAttachments || this.sendingReply || this.deletingAttachmentId) return;
        this.selected = null;
        this.replyDraft = '';
        this.activeDetailTab = 'overview';
        await this.service.render();
    }

    public async selectDetailTab(tab: BuyerDetailTab) {
        if (this.activeDetailTab === tab) return;
        this.activeDetailTab = tab;
        await this.service.render();
    }

    public async assign() {
        if (!this.selected || this.saving) return;
        const assignee = this.assigneeDraft.trim();
        if (!assignee) {
            await this.service.modal.error('담당자 식별자를 입력해주세요.');
            return;
        }
        await this.mutate(
            'assign_market_consultation',
            { id: this.selected.id, assignee },
            '담당자가 배정되었습니다.',
            '담당자 배정에 실패했습니다.'
        );
    }

    public async updateStatus() {
        if (!this.selected || this.saving) return;
        if (this.statusDraft === this.selected.status) {
            await this.service.modal.error('현재 상태와 다른 상태를 선택해주세요.');
            return;
        }
        await this.mutate(
            'update_market_consultation_status',
            {
                id: this.selected.id,
                status: this.statusDraft,
                reason: this.statusReason.trim()
            },
            '구매상담 상태가 변경되었습니다.',
            '구매상담 상태 변경에 실패했습니다.'
        );
    }

    public async addMessage() {
        if (!this.selected || this.saving) return;
        const body = this.messageDraft.trim();
        if (!body) {
            await this.service.modal.error('내부 메시지 내용을 입력해주세요.');
            return;
        }

        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const id = this.selected.id;
            const response = await wiz.call('add_market_consultation_message', { id, body });
            if (response.code !== 201) {
                throw new Error(this.responseError(response, '내부 메시지 추가에 실패했습니다.'));
            }
            this.messageDraft = '';
            await this.loadDetail(id, false);
            await this.service.modal.success('내부 메시지가 추가되었습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '내부 메시지 추가에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async uploadReplyAttachments(event: any) {
        const input = event?.target as HTMLInputElement;
        const files = input?.files ? Array.from(input.files) as File[] : [];
        if (input) input.value = '';
        if (!this.selected || !files.length || this.uploadingReplyAttachments || this.sendingReply) return;

        const currentDrafts = this.selected.reply_attachments.filter((item) => item.status === 'DRAFT').length;
        if (currentDrafts + files.length > 10) {
            await this.service.modal.error('답변 서류는 한 번에 최대 10개까지 탑재할 수 있습니다.');
            return;
        }
        for (const file of files) {
            const validation = this.validateReplyAttachment(file);
            if (validation) {
                await this.service.modal.error(validation);
                return;
            }
        }

        const id = this.selected.id;
        this.uploadingReplyAttachments = true;
        this.replyUploadProgress = 0;
        this.errorMessage = '';
        await this.service.render();
        try {
            for (let index = 0; index < files.length; index += 1) {
                const form = new FormData();
                form.append('id', id);
                form.append('file', files[index]);
                const response: any = await this.service.file.upload(
                    wiz.url('upload_market_consultation_attachment'),
                    form,
                    async (percent: number) => {
                        this.replyUploadProgress = Math.round(
                            ((index + percent / 100) / files.length) * 100
                        );
                        await this.service.render();
                    }
                );
                this.uploadResponseData(response);
            }
            await this.loadDetail(id, false);
            await this.service.modal.success(files.length + '개 답변 서류를 탑재했습니다.');
        } catch (error) {
            this.errorMessage = this.uploadErrorText(error, '답변 서류 탑재에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.uploadingReplyAttachments = false;
            this.replyUploadProgress = 0;
            await this.service.render();
        }
    }

    public async deleteReplyAttachment(attachment: ReplyAttachment) {
        if (
            !this.selected
            || !attachment?.id
            || attachment.status !== 'DRAFT'
            || this.deletingAttachmentId
            || this.sendingReply
        ) return;
        const confirmed = await this.service.modal.show({
            title: '답변 서류 삭제',
            message: (attachment.file_name || '선택한 서류') + '을(를) 삭제할까요?',
            action: '삭제',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'error'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.deletingAttachmentId = attachment.id;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('delete_market_consultation_attachment', {
                id,
                attachment_id: attachment.id
            });
            if (response.code !== 200) {
                throw new Error(this.responseError(response, '답변 서류 삭제에 실패했습니다.'));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success('답변 서류를 삭제했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '답변 서류 삭제에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.deletingAttachmentId = '';
            await this.service.render();
        }
    }

    public async sendReply() {
        if (
            !this.selected
            || this.sendingReply
            || this.uploadingReplyAttachments
            || this.deletingAttachmentId
        ) return;
        const body = this.replyDraft.trim();
        if (!body) {
            await this.service.modal.error('의뢰자에게 전송할 답변 내용을 입력해주세요.');
            return;
        }

        const attachments = this.selected.reply_attachments.filter((item) => item.status === 'DRAFT');
        const recipient = this.selected.requester?.email || '의뢰자';
        const confirmed = await this.service.modal.show({
            title: '관리자 답변 전송',
            message: recipient + '에게 답변' + (attachments.length ? '과 서류 ' + attachments.length + '개' : '') + '를 전송할까요?',
            action: '전송',
            cancel: '취소',
            status: 'success',
            actionBtn: 'success'
        });
        if (!confirmed) return;

        const id = this.selected.id;
        this.sendingReply = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const response = await wiz.call('add_market_consultation_message', {
                id,
                body,
                visibility: 'PUBLIC',
                attachment_ids: JSON.stringify(attachments.map((item) => item.id))
            });
            if (response.code < 200 || response.code >= 300) {
                throw new Error(this.responseError(response, '관리자 답변 전송에 실패했습니다.'));
            }
            this.replyDraft = '';
            await this.loadDetail(id, false);
            await this.service.modal.success('관리자 답변을 의뢰자에게 전송했습니다.');
        } catch (error) {
            this.errorMessage = this.errorText(error, '관리자 답변 전송에 실패했습니다.');
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.sendingReply = false;
            await this.service.render();
        }
    }

    public async previousPage() {
        if (this.loading || this.pagination.page <= 1) return;
        this.filters.page = this.pagination.page - 1;
        await this.load();
    }

    public async nextPage() {
        if (this.loading || this.pagination.page >= this.pagination.total_pages) return;
        this.filters.page = this.pagination.page + 1;
        await this.load();
    }

    public categoryLabel(category: ConsultationCategory) {
        switch (category) {
            case 'BUY_INQUIRY': return '구매 문의';
            case 'RIGHT_SPECIFIC_QNA': return '권리별 문의';
            case 'REQUIREMENT_QNA': return '요구사항 문의';
            case 'CASE_CONSULTATION': return '건별 상담';
            default: return category;
        }
    }

    public statusLabel(status: ConsultationStatus) {
        switch (status) {
            case 'RECEIVED': return '접수';
            case 'ASSIGNED': return '배정';
            case 'IN_PROGRESS': return '진행 중';
            case 'ON_HOLD': return '보류';
            case 'COMPLETED': return '완료';
            case 'CANCELLED': return '취소';
            default: return status;
        }
    }

    public statusClass(status: ConsultationStatus) {
        switch (status) {
            case 'RECEIVED': return 'border-amber-200 bg-amber-50 text-amber-700';
            case 'ASSIGNED': return 'border-sky-200 bg-sky-50 text-sky-700';
            case 'IN_PROGRESS': return 'border-violet-200 bg-violet-50 text-violet-700';
            case 'COMPLETED': return 'border-emerald-200 bg-emerald-50 text-emerald-700';
            case 'CANCELLED': return 'border-rose-200 bg-rose-50 text-rose-700';
            default: return 'border-slate-200 bg-slate-100 text-slate-600';
        }
    }

    public formatDate(value: string) {
        if (!value) return '-';
        const date = new Date(value);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat('ko-KR', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        }).format(date);
    }

    public attachmentStatusLabel(status: ReplyAttachment['status']) {
        if (status === 'DRAFT') return '전송 대기';
        if (status === 'PENDING') return '전송 처리 중';
        return '전송 완료';
    }

    public fileSize(value: number) {
        const size = Number(value || 0);
        if (size < 1024) return size + ' B';
        if (size < 1024 * 1024) return (size / 1024).toFixed(1) + ' KB';
        return (size / (1024 * 1024)).toFixed(1) + ' MB';
    }

    private validateReplyAttachment(file: File) {
        const allowed = ['pdf', 'jpg', 'jpeg', 'png', 'hwp', 'hwpx', 'doc', 'docx', 'xls', 'xlsx'];
        const extension = (file.name.split('.').pop() || '').toLowerCase();
        if (!allowed.includes(extension)) {
            return 'PDF, 이미지, HWP, Word 또는 Excel 서류만 탑재할 수 있습니다.';
        }
        if (!file.size) return '빈 답변 서류는 탑재할 수 없습니다.';
        if (file.size > 20 * 1024 * 1024) return '답변 서류는 파일당 20MB 이하여야 합니다.';
        return '';
    }

    private uploadResponseData(response: any) {
        const payload = response?.responseJSON || response;
        const status = Number(payload?.code || response?.status || 200);
        if (!payload || status >= 400) {
            const message = payload?.data?.error?.message
                || payload?.error?.message
                || payload?.message
                || '답변 서류 탑재에 실패했습니다.';
            throw new Error(message);
        }
        return payload.data;
    }

    private uploadErrorText(error: any, fallback: string) {
        const payload = error?.responseJSON || error;
        return payload?.data?.error?.message
            || payload?.error?.message
            || payload?.message
            || fallback;
    }

    private async mutate(action: string, payload: any, success: string, fallback: string) {
        this.saving = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const id = this.selected?.id || '';
            const response = await wiz.call(action, payload);
            if (response.code !== 200) {
                throw new Error(this.responseError(response, fallback));
            }
            await this.loadDetail(id, false);
            await this.service.modal.success(success);
        } catch (error) {
            this.errorMessage = this.errorText(error, fallback);
            await this.service.modal.error(this.errorMessage);
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    private applyDetail(detail: ConsultationDetail) {
        detail.messages = Array.isArray(detail.messages) ? detail.messages : [];
        detail.status_history = Array.isArray(detail.status_history) ? detail.status_history : [];
        detail.reply_attachments = Array.isArray(detail.reply_attachments)
            ? detail.reply_attachments
            : [];
        this.selected = detail;
        this.assigneeDraft = detail.assigned_to || '';
        this.statusDraft = detail.status;
        this.statusReason = '';
    }

    private updateListItem(detail: ConsultationDetail | null) {
        if (!detail) return;
        const index = this.items.findIndex((item) => item.id === detail.id);
        if (index < 0) return;
        this.items[index] = {
            ...this.items[index],
            category: detail.category,
            subject: detail.subject,
            requester: detail.requester,
            privacy_consent: detail.privacy_consent,
            status: detail.status,
            assigned_to: detail.assigned_to,
            created_at: detail.created_at,
            updated_at: detail.updated_at,
            body_preview: detail.body
        };
    }

    private responseError(response: any, fallback: string) {
        const error = response?.data?.error;
        if (!error) return fallback;
        const messages: any = {
            CORE_API_PROXY_NOT_CONFIGURED: 'Core API 연동 설정이 필요합니다',
            CORE_API_UNAVAILABLE: 'Core API에 연결할 수 없습니다. 잠시 후 다시 시도해주세요.',
            UNAUTHORIZED: 'Core API 관리자 토큰을 확인해주세요.',
            ADMIN_AUTH_NOT_CONFIGURED: 'Core API 관리자 인증이 설정되지 않았습니다.',
            CONSULTATION_NOT_FOUND: '선택한 구매상담을 찾을 수 없습니다.',
            INVALID_CATEGORY: '구매상담 유형을 확인해주세요.',
            INVALID_STATUS: '변경할 구매상담 상태를 확인해주세요.',
            ATTACHMENT_STORAGE_UNAVAILABLE: '답변 서류 저장소를 사용할 수 없습니다.',
            ATTACHMENT_NOT_FOUND: '선택한 답변 서류를 찾을 수 없습니다.',
            ATTACHMENT_ALREADY_SENT: '이미 전송된 답변 서류가 포함되어 있습니다.',
            UNSUPPORTED_ATTACHMENT_TYPE: '지원하지 않는 답변 서류 형식입니다.',
            ATTACHMENT_TOO_LARGE: '답변 서류는 파일당 20MB 이하여야 합니다.',
            REPLY_TOO_LONG: '답변 내용과 첨부 서류 링크를 합쳐 5000자 이내로 작성해주세요.'
        };
        return messages[error.code] || error.message || fallback;
    }

    private errorText(error: any, fallback: string) {
        return error instanceof Error && error.message ? error.message : fallback;
    }
}

export default PageIpMarketBuyerInquiriesComponent;